import React, { useCallback } from "react";
import { HeaderPickerButton } from "../../../Team/TeamHomeNavigator/TeamHome/HeaderPickerButton";
import { PopoverButton } from "../../../../common/PopoverButton";
import { StorecastPickerPopover } from "../../../StorecastPickerPopover/StorecastPickerPopover";
import { graphql, useFragment } from "react-relay";
import { StorecastPickerButton_dashboard$key } from "./__generated__/StorecastPickerButton_dashboard.graphql";
import { StorecastPickerButton_dasbhoards$key } from "./__generated__/StorecastPickerButton_dasbhoards.graphql";

export function StorecastPickerButton(props: {
  currentDashboard: StorecastPickerButton_dashboard$key;
  dashboards: StorecastPickerButton_dasbhoards$key;
  onChangeDashboard?: (dashboard: { id: string }) => void;
  isCompact: boolean;
}) {
  const dashboard = useFragment(
    graphql`
      fragment StorecastPickerButton_dashboard on Dashboard {
        id
        name
      }
    `,
    props.currentDashboard
  );

  const dashboards = useFragment(
    graphql`
      fragment StorecastPickerButton_dasbhoards on Dashboard
      @relay(plural: true) {
        id
        ...StorecastPickerPopoverDashboards
      }
    `,
    props.dashboards
  );

  const popoverContent = useCallback(
    (close: () => void) =>
      props.onChangeDashboard ? (
        <StorecastPickerPopover
          currentDashboardId={dashboard.id}
          onClose={close}
          onSelectItem={props.onChangeDashboard}
          dashboards={dashboards}
        />
      ) : null,
    [dashboard.id, dashboards, props.onChangeDashboard]
  );

  const button = useCallback(
    (open: () => void) => {
      return (
        <HeaderPickerButton
          onPress={props.onChangeDashboard ? open : undefined}
          value={dashboard.name}
          tintColor="text-primary"
          isCompact={props.isCompact}
        />
      );
    },
    [props.isCompact, dashboard.name, props.onChangeDashboard]
  );

  return (
    <PopoverButton popoverContent={popoverContent}>{button}</PopoverButton>
  );
}
